import './lib/fullpage'

$(document).ready(function() {
  $('#fullpage').fullpage({
    anchors: ['firstPage', 'secondPage', '3rdPage', '4thPage', '5thPage'],
    sectionsColor: ['#73bf6c', '#878484', '#d7d7d7', '#ffffff', '#d7d7d7'],
    navigation: true,
    navigationPosition: 'left',
    responsive: 900,
    fitToSection: false,
    css3:false,
    autoScrolling: false
  });
});
